module.exports = {
	"adMob": {
		"bannerID": "",
		"interstitialID": "",
		"isTesting": true,
		"showBannerAds": false,
		"showinterstitialAds": false
	},
	"login": {
		"facebookID": "",
		"facebookLogin": false,
		"googleAndroidId": "",
		"googleIOSid": "",
		"googleLogin": false,
		"welcomeText": "Welcome to React  App"
	},
	"orders": {
		"sendEmailOnOrder": true,
		"sendToEmail": ""
	},
	"paypal": {
		"acceptPayments": true,
		"cancel_url": "",
		"city": "San Jose",
		"clientid": 1,
		"country_code": "US",
		"currency": "$",
		"includeShippingInfo": "",
		"postal_code": 95131,
		"return_url": "",
		"sandBoxMode": true,
		"secretKey": "",
		"state": "CA"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/builder/appsettings.json
// module id = 1211
// module chunks = 0